import { ref, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { useCalculatorsStore } from '../store/calculators';

export function useSelectCalculator() {
  const currentCalculatorId = ref<null | number>(null);

  const router = useRouter();

  function selectCalculator(id: number) {
    currentCalculatorId.value = id;

    router.push(`/${currentCalculatorId.value}`);
  }

  const calculatorsStore = useCalculatorsStore();
  const options = computed(() => calculatorsStore.data);

  const route = useRoute();
  watch(
    () => route.params.calculatorId,
    () => {
      const id = Number(route.params.calculatorId);

      currentCalculatorId.value = id;
    },
    {
      immediate: true,
    }
  );

  return { currentCalculatorId, options, selectCalculator };
}
